import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { v4 as newGuid } from "uuid";
import { useSession } from "../../../../hooks";
import { useCreateSection } from "../../../../http";
import { IBlock } from "../../../../models";
import { lexorank } from "../../../../utilities";
import { CreateEditSectionForm, ICreateEditSectionFormState } from "./CreateEditSectionForm";
import { usePlanContext } from "./PlanContext";

interface IProps {
  visible: boolean;
  block: IBlock;
  onAdded: () => void;
  onCancelled: () => void;
}

const CreateSectionModal = (props: IProps) => {
  const { planGuid } = usePlanContext();
  const { userId } = useSession();
  const { mutate, isLoading } = useCreateSection();
  const { formState, control, handleSubmit, reset } = useForm<ICreateEditSectionFormState>({
    defaultValues: {
      name: "",
      hintText: "",
    },
  });

  function handleCreateClicked() {
    handleSubmit((data) => {
      mutate(
        {
          planGuid: planGuid,
          blockGuid: props.block.guid,
          guid: newGuid(),
          name: data.name,
          hintText: data.hintText,
          sortOrder: lexorank.getNextRank(props.block.sections),
          createdByUserId: userId,
        },
        {
          onSuccess: () => {
            reset(undefined, { keepDefaultValues: true });
            props.onAdded();
          },
        }
      );
    })();
  }

  function handleClose(_event: object, reason: "backdropClick" | "escapeKeyDown") {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    handleCancelClicked();
  }

  function handleCancelClicked() {
    props.onCancelled();
  }

  return (
    <Dialog open={props.visible} onClose={handleClose}>
      <DialogTitle>Create Section</DialogTitle>
      <DialogContent>
        <CreateEditSectionForm formState={formState} control={control} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" disabled={isLoading} onClick={handleCancelClicked}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isLoading}
          endIcon={isLoading ? <CircularProgress size={20} sx={{ color: "grey.400" }} /> : null}
          onClick={handleCreateClicked}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { CreateSectionModal };
